import React from "react";

const Title = ({ id, children, addClass, style, tagName, type, removeWeight }) => {
  const defaultSize = "__t_d";
  const defaultTagName = "h2";

  const titleType = {
    large: "__t_l",
    big: "__t_b",
    small: "__t_s",
  }[type];

  const CustomTag = tagName || defaultTagName;
  return (
    <CustomTag
      id={id}
      style={style}
      data-test="Title"
      data-component_name="Title"
      className={`__t ${addClass ? addClass : ""} ${type ? titleType : defaultSize} ${
        removeWeight ? "__t_w" : ""
      }`}
    >
      {children}
    </CustomTag>
  );
};

export default Title;
